<template>
    <div class="bodyText">
        <div class="btnsBos">
            <p class="start-button" @click="getBackt"> 确认</p>
        </div>

        <div class="textbox" id="textbox">
         
        </div>

    </div>

</template>
<script>
import { firstApi } from '../http/api.js'
export default {
    name: 'makeSureText',

    data() {
        return {
            text: '',
            title: ''
        }
    },
    methods: {
        getText() {
            firstApi.getContract({}).then(res => {
                if (res.code == 1) {
                 //   this.text = res.data.content
                    this.title = res.data.cName
                    document.getElementById("textbox").innerHTML = res.data.content
                }

            })
        },
        getBackt() {
            this.$router.push({ path: '/' })
        }
    },
    mounted() {
        this.getText()
    }
}
</script>
<style scoped lang="scss">
div {
    box-sizing: border-box;
}

.bodyText {
    padding: 0 20px;

    h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 20px 0;
    }

    p {
        font-size: 14px;
        line-height: 20px;
    }

    .btnsBos {
        position: fixed;
        bottom: 20px;
        text-align: center;
        
        width: calc(100% - 40px);

        .start-button {
            width: 140px;
            padding: 10px 10px;
            margin: 0 auto;
            text-align: center;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 10px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 20px;


        }
    }



    .textbox {
        
        white-space: pre-wrap;
        padding-bottom:80px;
    }
}
</style>